if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const prevArrow = `<button type="button" class="slick-prev slick-arrow"><span>Prev</span><svg width="23" height="32" viewBox="0 0 23 32" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 22 16 L 16 24 V 32 L 0 16 L 16 0 V 8 Z M 8 8 V 24 M 12 4 V 28" /></svg></button>`;
const nextArrow = `<button type="button" class="slick-next slick-arrow"><span>Next</span><svg width="23" height="32" viewBox="0 0 23 32" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 1 16 L 7 24 V 32 L 23 16 L 7 0 V 8 Z M 16 8 V 24 M 12 4 V 28" /></svg></button>`;
const slickOps = {
	accessibility: true,
	prevArrow: prevArrow,
	nextArrow: nextArrow,
};

const cmsForms_connectFromToDatepickers = () => {
	$('.form-module').each(function (i, cmsForm) {
		const $inputFrom = $('.js-form-datefrom.date .datepicker', cmsForm);
		const $inputTo = $('.js-form-dateto.date .datepicker', cmsForm);

		$inputFrom.datepicker('option', 'onSelect', function (date) {
			if ($inputTo.length < 1) {
				console.warn('js-form-dateto not found');
				return false;
			}

			setTimeout(function () {
				$inputTo.datepicker('option', 'minDate', date);
				$inputTo.datepicker('show');
			}, 10);
		});
	});
};

const createFrameL3inForms = () => {
	document.querySelectorAll('.form-module-wrapper').forEach((formw) => {
		if (formw.querySelectorAll('.frame_l3').length < 1) {
			formw.insertAdjacentHTML('afterbegin', `<div class="frame_l3-gold animate-fade" data-fromjs></div>`);
		}
	});
};

const createFrameInBtn = () => {
	document.querySelectorAll('.btn, .signup-btn').forEach((btn) => {
		if (btn.querySelectorAll('.btnBox').length < 1) {
			btn.insertAdjacentHTML('afterbegin', `<span class="btnBox" data-fromjs></span>`);
		}
	});
};

const toggleMainNav = (event, btn) => {
	event.preventDefault();

	const navID = btn.getAttribute('href');
	if (document.querySelector(navID)) {
		btn.classList.toggle('active');

		document.querySelector(navID).classList.toggle('active');
		document.body.classList.toggle('noscroll', document.querySelector(navID).classList.contains('active'));
	}
};

const splitWordChars = (word) => {
	const chars = word.trim().split('');
	const wrappedChars = chars.map((char) => `<span class="char" data-fromjs>${char}</span>`).join('');
	return wrappedChars;
};

(function () {
	// THREE COLs MOBILE TOGGLE CARD
	if (window.innerWidth < 767) {
		document.querySelectorAll('.threeColsMod').forEach((mod) => {
			mod.querySelectorAll('.threeColsMod_item').forEach((item) => {
				item.addEventListener('click', () => {
					mod.querySelectorAll('.threeColsMod_item').forEach((itm) => {
						if (itm !== item) itm.classList.remove('showbox');
					});
					item.classList.toggle('showbox');
				});
			});
		});
	}

	// CUSTOM SELECT
	document.querySelectorAll('[data-custom_select]').forEach((select) => {
		const currentField = select.querySelector('input');

		if (currentField) {
			currentField.addEventListener('click', () => select.classList.toggle('active'));
		}

		select.querySelectorAll('li').forEach((li) => {
			li.addEventListener('click', () => {
				if (currentField) {
					currentField.value = li.dataset.value;
				}

				select.querySelectorAll('li').forEach((l) => l.classList.remove('active'));
				li.classList.add('active');

				select.classList.remove('active');
			});
		});
	});

	// CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.remove('active');
			});
		}
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.add('active');
			});
		}
	});

	// SPECIALS T&C TOGGLE
	$('.specialsTerms_link').click(function (e) {
		e.preventDefault();
		const $link = $(this);

		if ($($.attr(this, 'href')).length > 0) {
			$($.attr(this, 'href'))
				.stop()
				.slideToggle(500, function () {
					$link.toggleClass('active', $(this).is(':visible'));
				});
		}
	});

	// PRELOAD
	if (document.getElementById('preload')) {
		setTimeout(() => {
			document.body.classList.remove('noscroll');
			document.getElementById('preload').classList.add('loaded');
		}, 4000);
	}

	// SPLIT TEXT FOR TYPING ANIMATION
	if (window.innerWidth > 767) {
		document.querySelectorAll('[data-splitchars]').forEach((mod) => {
			const initialHTML = mod.innerHTML;
			const words = mod.textContent.trim().split(' ');
			// const wordsUpdated = words.map((word) => `<span class="word" data-fromjs>${splitWordChars(word)}</span>`);
			const wordsUpdated = words.map((word) => splitWordChars(word));
			let updatedHTML = initialHTML;

			words.forEach((word, i) => {
				updatedHTML = updatedHTML.replace(word, wordsUpdated[i]);
			});

			mod.innerHTML = updatedHTML;
		});
	}

	// ACCORDION TOGGLE
	document.querySelectorAll('.accordionMod').forEach((accordion) => {
		accordion.querySelectorAll('.accordionMod_head').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.accordionMod_item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

	// TOGGLE MAIN NAV
	document.querySelectorAll('[data-toggle_nav]').forEach((btn) => {
		btn.addEventListener('click', (e) => toggleMainNav(e, btn));
	});

	// TOGGLE FADE ON CLICK
	document.querySelectorAll('[data-toggle_fade]').forEach((btn) => {
		const target = document.querySelector(btn.getAttribute('href'));
		if (target) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				btn.classList.toggle('active');
				target.classList.toggle('active');
			});
		}
	});

	// WRAP MODULE TABLES
	document.querySelectorAll('.tableModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// MOBILE TABLE TO DROPDOWNS
	const tablesResp = document.querySelectorAll('.tableModule table');
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}

	// APPEND FRAME DIVs TO FORMs
	createFrameL3inForms();

	// APPEND FRAME SPAN TO BTNs
	createFrameInBtn();

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// FANCYBOX SETTINGS
	$.fancybox.defaults.touch = false;
	$.fancybox.defaults.autoFocus = false;
	$.fancybox.defaults.smallBtn = true;
	$.fancybox.defaults.btnTpl.smallBtn = `<button class="fancybox-button fancybox-close-small" title="{{CLOSE}}" type="button" data-fancybox-close><svg fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowLeft = `<button class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" type="button" data-fancybox-prev><span>Prev</span><svg width="23" height="32" viewBox="0 0 23 32" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 22 16 L 16 24 V 32 L 0 16 L 16 0 V 8 Z M 8 8 V 24 M 12 4 V 28" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `<button class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" type="button" data-fancybox-next><span>Next</span><svg width="23" height="32" viewBox="0 0 23 32" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 1 16 L 7 24 V 32 L 23 16 L 7 0 V 8 Z M 16 8 V 24 M 12 4 V 28" /></svg></button>`;

	// *WORKING ONLY FOR SLIDESTOSHOW:1
	/* function slickSingleSlideCheckClones(slick, currentSlide, nextSlide) {
		const lastSlide = slick.slideCount - 1;

		if (slick.options.slidesToShow === 1) {
			$('.slick-cloned', slick.$slider).removeClass('slick-activeclone');

			if (currentSlide === lastSlide && nextSlide === 0) {
				$(
					`[data-slick-index="${slick.slideCount}"]`,
					slick.$slider
				).addClass('slick-activeclone');
			}

			if (currentSlide === 0 && nextSlide === lastSlide) {
				$(`[data-slick-index="-1"]`, slick.$slider).addClass(
					'slick-activeclone'
				);
			}
		}
	} */

	// $('.sym-slides').on(
	// 	'beforeChange',
	// 	function (e, slick, currentSlide, nextSlide) {
	// 		slickSingleSlideCheckClones(slick, currentSlide, nextSlide);
	// 	}
	// );

	$('.sym-slides').slick(slickOps);

	$('[data-slick_prev]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('[data-slick_next]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});

	$('[data-slick-goto]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		const target = $(this).data('slick-goto') ? parseInt($(this).data('slick-goto')) : 0;

		$curSlider.slick('slickGoTo', target);
		$(this).siblings('[data-slick-goto]').removeClass('active');
		$(this).addClass('active');
	});

	$(window).load(function () {
		// *CONNECT FORM DATEPICKERs FORM-TO (ONLY FOR CMS FORMs)
		cmsForms_connectFromToDatepickers();
	});
})();
